import { BaseTabInterface } from 'base';
import { BaseCustomerProviderTabsEnum } from '../../inquiry/_enums/base-customer-provider-tabs.enum';

export const BaseCustomerProviderModalTabs: BaseTabInterface[] = [
  {
    id: BaseCustomerProviderTabsEnum.MaterData,
    title: 'masterData',
  },
  {
    id: BaseCustomerProviderTabsEnum.EmployeeLease,
    title: 'customer.related.temporaryEmployment',
  },
  {
    id: BaseCustomerProviderTabsEnum.IZS,
    title: 'izs.label',
    data: {
      badge: 'assets-global/images/izs/izs-logo-multicolor.svg',
      isImageBadge: true,
    },
  },
];
